export default __webpack_public_path__ + "static/ai-solutions-with-roadmap5-601c1847fa15f0a35354c43478d1bb52.jpg";